import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Accueil', path: '/' },
  { label: 'À propos', path: '/a-propos' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/731ba6a5-d861-4514-b45b-3ebef5d11079.png"
            alt="BONIEK Logo"
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.path
                  ? scrolled
                    ? 'text-[#1a2e4a]'
                    : 'text-white'
                  : scrolled
                  ? 'text-gray-500 hover:text-[#1a2e4a]'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="whitespace-nowrap px-5 py-2 rounded-md text-sm font-medium bg-[#1a2e4a] text-white hover:bg-[#243d61] transition-colors duration-200 cursor-pointer"
          >
            Nous contacter
          </Link>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`text-xl ${scrolled ? 'text-[#1a2e4a]' : 'text-white'} ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium py-2 border-b border-gray-50 whitespace-nowrap ${
                location.pathname === link.path ? 'text-[#1a2e4a]' : 'text-gray-600'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="whitespace-nowrap mt-2 px-5 py-2 rounded-md text-sm font-medium bg-[#1a2e4a] text-white text-center cursor-pointer"
          >
            Nous contacter
          </Link>
        </div>
      )}
    </header>
  );
}
